/* eslint-disable */
var RemoteAction = function() {}

/**
 * Set action property.
 * @param {string} action Sets the action property.
 */
RemoteAction.prototype.setAction = function(action) {
    if (!action || typeof action !== 'string') {
        throw new RemoteActionException('Parameter is not a string.');
        return;
    }

    this.action = action;

    return this;
}

/**
 * Set error handler.
 * @param {function} fn Function reference.
 */
RemoteAction.prototype.setErrorHandler = function(fn) {
    if (typeof fn === 'function') {
        this.errorHandler = fn;
    } else {
        throw new RemoteActionException('Parameter is not a function.');
    }

    return this;
};

/**
 * Set timeout.
 * @param {Number} timeout timeout value in seconds. Visualforce remoting default is 30 seconds
 */
RemoteAction.prototype.setTimeout = function(timeout) {
    if (!(timeout && typeof timeout === 'number' && timeout != Infinity)) throw new RemoteActionException('timeout param is not a number.');

    if(timeout < 1) throw new RemoteActionException('Minimum allowed timeout is 1 second.');

    if(timeout > 120) throw new RemoteActionException('Max allowed timeout is 120 seconds.');
         
    this.timeout = timeout * 1000; // convert to milliseconds

    return this;
};

/**
 * Handles the call to the remote action.
 * @param {Array} params An array of params being passed to the remote action.
 * @param {function} callback The callback function that will be invoked with the remote action result.
 */
RemoteAction.prototype.invoke = function(params, callback, config) {
    if (!params || !Array.isArray(params)) {
        throw new RemoteActionException('Params parameter is not an array.');
        return;
    }

    if (callback) {
        if (typeof callback !== 'function') {
            throw new RemoteActionException('Callback parameter is not a function.');
            return;
        }

        this.callback = callback;
    }

    if (config) {
        if (typeof config !== 'object') {
            throw new RemoteActionException('Config param is not an object.');
            return;
        }
    }

    config = config || {};
    config.timeout = this.timeout || config.timeout;

    params.unshift(this.action);
    params.push(this._handleResult.bind(this));
    params.push(config);

    Visualforce.remoting.Manager.invokeAction.apply(Visualforce.remoting.Manager, params);
};

/**
 * Callback for the invoked action result
 * @param {object} result Whatever the invoked action returns.
 * @param {object} event Contains info about the result of the invoked action call.
 */
RemoteAction.prototype._handleResult = function(result, event) {
    if (event.status) {
        this.callback(result);
    } else {
        if (this.errorHandler) {
            this.errorHandler.call(this.errorHandler, result, event);
        }
    }
};

/**
 * Exceptions
 */
var RemoteActionException = function(message) {
    this.message = message;
    this.name = 'RemoteActionException';
};

export default RemoteAction;